"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var Dialog_1 = require("mobile/components/Dialog");
function default_1(children, showTime, cb) {
    if (showTime === void 0) { showTime = 2000; }
    if (cb === void 0) { cb = function () { }; }
    var body = window.document.body;
    var dialogElm = window.document.createElement("div");
    body.appendChild(dialogElm);
    var dialogComponent;
    var autoHideTimeout = null;
    var hideDialog = function () {
        if (typeof dialogComponent !== "undefined") {
            dialogComponent.hide();
            setTimeout(function () {
                body.removeChild(dialogElm);
                cb();
            }, 500);
        }
    };
    var DialogComponent = function () { return (React.createElement(Dialog_1.default, { show: false, style: {
            zIndex: 99999999,
            background: "none"
        }, ref: function (currentComponent) { return (dialogComponent = currentComponent); }, contentAttributes: {
            style: {
                zIndex: 99999999,
                borderRadius: "0.375rem",
                padding: "1rem",
                lineHeight: "1.25rem",
                fontSize: "0.875rem",
                background: "rgba(0, 0, 0,0.8)",
                width: "18.75rem"
            }
        }, onClickCB: function () {
            clearTimeout(autoHideTimeout);
            hideDialog();
        } },
        React.createElement("div", { style: { width: "100%", textAlign: "center", wordBreak: "break-word" } }, children || "Tooltip"))); };
    ReactDOM.render(React.createElement(DialogComponent, null), dialogElm, function () {
        dialogComponent.show();
        autoHideTimeout = setTimeout(function () {
            hideDialog();
        }, showTime);
    });
}
exports.default = default_1;
